import { Dropdown } from 'antd'
import ConfirmationModal from 'components/ConfirmationModal/ConfirmationModal'
import { NAMESPACE } from 'locale'
import { goalsConstants } from 'locale/goals'
import { useTranslation } from 'react-i18next'
import DotsButton from '../DotsMenu/DotsMenu'

type DotsMenuProps = {
  onUnlink: () => void
  testId?: string
}

const DotsMenuSupport = (props: DotsMenuProps) => {
  const { onUnlink, testId } = props
  const { t } = useTranslation(NAMESPACE.GOALS)

  const items = [
    {
      key: '1',
      label: (
        <ConfirmationModal>
          <div onClick={onUnlink}>{t(goalsConstants.UNLINK)}</div>
        </ConfirmationModal>
      )
    }
  ]

  return (
    <Dropdown
      trigger={['click']}
      menu={{
        items
      }}
    >
      <DotsButton data-testid={testId} />
    </Dropdown>
  )
}

export default DotsMenuSupport
